<template>
  <div id="app">
    <div
      id="ReminderBox"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ReminderBox"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="lbl_ReminderTitle" class="modal-title">
              {{ $t("Reminder") }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div id="lbl_ReminderContent" class="modal-body">
            <div class="form-row">
              <div class="form-group col">
                {{ errormessage }}
              </div>
            </div>

            <div class="form-row">
              <button
                class="btn btn-primary col-md-8"
                @click="onReminderCancel()"
                style="margin: auto"
              >
                {{ $t("Back") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <canvas id="load" ref="load"></canvas>

    <div class="main-wrapper container">
      <Navbar iconAction="0" :changeurl="changeurl()"></Navbar>

      <nav
        class="navbar navbar-secondary"
        style="background-color: initial; box-shadow: 0 0px 0px rgb(0 0 0 / 0%)"
      >
        <div class="container">
          <h3>{{ $t("Welcome to KLUB 11") }}</h3>
        </div>
      </nav>

      <!-- Main Content -->
      <div class="main-content">
        <section class="section">
          <div class="section-body">
            <div class="card col-md-6" style="margin: auto">
              <div class="card-header">
                <h4>{{ desc }}</h4>
              </div>
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-md-4">

                    <vue-country-code
                      class="form-control"
                      ref="flagstrap"
                      :onlyCountries="this.countryList"
                      :enabledCountryCode="true"
                      :enabledFlags="false"
                      :disabledFetchingCountry="false"
                      :defaultCountry="this.defaultCountry"
                      @onSelect="onSelect"
                      :disabled="this.prefill"
                    >
                    </vue-country-code>
                  </div>
                  <div class="form-group col-md-8">
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      id="phone_num"
                      v-model="phone_num"
                      ref="phone_num"
                      :placeholder="$t('Enter your mobile number')"
                      @input="phonenumber()"
                      @keydown="onkeyDownHandler"
                      :disabled="this.prefill"
                    />
                    <span
                      ref="phoneerror"
                      id="phoneerror"
                      style="color: red; font-size: 10px"
                    ></span>
                  </div>
                </div>
                <!-- <p style="text-align: center" v-if="k11purposes == null">
                  <a :href="this.continueWithEmailUrl" @click="changeurl()">{{
                    $t("Continue with Email")
                  }}</a>
                </p> -->
                <!-- <p style="text-align: center" v-if="k11purposes == 0">
                  <a :href="this.continueWithEmailUrl" @click="changeurl()">{{
                    $t("Continue with Another Email")
                  }}</a>
                </p> -->
                <div class="consents-content" id="k11" v-if="!this.isWechat">
                    <p v-html="$t('Login Consent Desc')"></p>
                    <div class="child-check-box-container">
                      <div class="child-consent-item">
                          <div class="flex">
                              <div ref="checkbox1"
                                   class="check-box-container child-checkbox"
                                    :class="{ active: this.isCheckbox1Pass }"
                                    v-on:click="onClickCheckbox1()"></div>
                              <p :class="switchColor(this.isCheckbox1TextInRed)" v-html="$t('Login Consent Checkbox 1')"></p>
                          </div>
                      </div>
                      <div class="child-consent-item">
                          <div class="flex">
                              <div ref="checkbox2"
                                   class="check-box-container child-checkbox"
                                    :class="{ active: this.isCheckbox2Pass }"
                                    v-on:click="onClickCheckbox2()"></div>
                              <p :class="switchColor(this.isCheckbox2TextInRed)" v-html="$t('Login Consent Checkbox 2')"></p>
                          </div>
                      </div>
                </div>
                </div>
                <div id="mcaptcha__widget-container">
                </div>
                <span
                    ref="loginerror"
                    id="loginerror"
                    style="color: red; font-size: 10px"
                  ></span>
                  <button
                      class="btn col-md-12"
                      :class="this.isAbleSumbit() ? `btn-primary` : `btn-primary disabled`"
                      id="sumbit"
                      ref="sumbit"
                      @click="sumbit()"
                  >
                  <span
                    class="spinner-border spinner-border-sm"
                    style="margin-right: 5px"
                    id="spin"
                    role="status"
                    aria-hidden="true"
                    ref="spin"
                    v-if="spinner"
                  >
                  </span>
                  <span id="loading" ref="loading">{{ $t("Continue") }}</span>
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <button id="tmp" hidden></button>
  </div>
</template>
<style>
#country_code {
  border: none;
  border-bottom: 1px solid #000000;
}

canvas {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  box-sizing: border-box;
  margin: 0;
  width: 100%;
  height: 100%;
}

.vue-country-select .current .country-code {
  margin-left: 10px;
  margin-right: 10px;
}

.consents-content {
    font-size: 14px;
    line-height: 16px;
    color: #928f89;
}

.consents-content-red,
.consents-content-red a
 {
    font-size: 14px;
    line-height: 16px;
    color: red;
}

.child-check-box-container {
    padding-top: 12px;
}

.flex {
    display: flex;
    flex: 1 0 100%;
}

.check-box-container {
    border: 2px solid #cecdca;
    border-radius: 8px;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-right: 8px;
}

.check-box-container.active::before {
    content: "";
    display: block;
    transform: rotate(45deg);
    height: 11px;
    width: 5px;
    border-bottom: 2px solid white;
    border-right: 2px solid white;
    margin-left: 6px;
    margin-top: 2px;
}

.check-box-container.active {
    background-color: gray;
}

.consent-item p {
    margin-left: 8px;
}

</style>
<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import helper from "@/vueHelper";
import api from "@/api";
import config from "@/config";
import Navbar from "@/components/Navbar.vue";
// import VueRecaptcha from 'vue-recaptcha';
import {Country} from 'country-state-city';
import * as mCaptcha from '@mcaptcha/vanilla-glue';
import Receiver from "@mcaptcha/core-glue";
export default {
  components: { Navbar },
  data() {
    return {
      errormessage: "",
      desc: null,
      k11purposes: null,
      phone_num: "",
      spinner: false,
      disabled: true,
      selectedCountry: "",
      k11vipcode: null,
      k11accountno: null,
      kdpmembernumber: null,
      registered: false,
      defaultCountry: 'HK',
      countryList: [],
      callbackurl: null,
      hostname: false,
      token: "",
      McaptchaSitekey:"",
      McaptchaURL:"",
      prefill: false,
      isPhoneNumberPass: false,
      isCheckbox1Pass: false,
      isCheckbox2Pass: false,
      isCheckbox1TextInRed: false,
      isCheckbox2TextInRed: false,
      wx: window.__wxjs_environment === 'miniprogram',
      // continueWithEmailUrl: "./#/email_login",
      url: new URL(window.location.href)
    };
  },
  created() {
    this.hostname = window.location.hostname.indexOf("k11") > -1;

    const url = this.url
    // console.log("url.search",url.search)

    // this.setIsWechat(window.__wxjs_environment === 'miniprogram')

    if (url.searchParams.has("locale")) {
      let locale=url.searchParams.get("locale");
      if (locale === "en" || locale === "zh_CN" || locale === "zh_HK") {
        this.$store.commit("setAppLanguage", locale)
        this.$i18n.locale = locale;
      }
    }

    helper.loading();
    api.request(
      this,
      "post",
      "/migrationhub/getCountryList",
      {},
      function (r) {
        helper.done();
        if (r.success) {
          this.countryList = r.data.CountryList;
        }
      },
      function (r) {
        console.log(r);
        helper.done();
      },
      false,
      null
    );

    this.actionSetForceBlock(false);
    this.k11purposes = window.sessionStorage.getItem("k11purposes");

    if (url.searchParams.has("callbackurl")) {
      this.callbackurl = url.searchParams.get("callbackurl");
    } else if (
      window.sessionStorage.getItem("callbackurl") != null &&
      window.sessionStorage.getItem("callbackurl") != "" &&
      window.sessionStorage.getItem("callbackurl") != "null"
    ) {
      this.callbackurl = window.sessionStorage.getItem("callbackurl");
    }
    this.k11vipcode = window.sessionStorage.getItem("k11vipcode");
    this.k11accountno = window.sessionStorage.getItem("k11accountno");
    this.phone_num = window.sessionStorage.getItem("phone_num");
    if (this.k11purposes == "0") {
      this.desc = this.$t(
        "We couldn't find a registered account with the entered email, please login or register with your mobile number"
      );
    } else if (this.k11purposes == "1") {
      this.desc = this.$t(
        "Please confirm your mobile number for verification purposes"
      );
    } else {
      this.desc = this.$t("Please Enter your mobile number to continue");
    }
    let params = url.searchParams;
    if (params.has("country") && params.has("phone")) {
      const csc = Country.getAllCountries().find(v => v.phonecode === params.get("country"))
      this.phone_num = params.get("phone")
      if (csc != null) {
        this.defaultCountry = csc.isoCode;
      }
      // this.continueWithEmailUrl = `./${this.url.search}#/email_login`
      this.prefill = true;
    }

    window.sessionStorage.clear();
    this.resetWeChatRelatedLocalStorage()
  },
  updated() {
    if (this.k11purposes == "0") {
      this.desc = this.$t(
        "We couldn't find a registered account with the entered email, please login or register with your mobile number"
      );
    } else if (this.k11purposes == "1") {
      this.desc = this.$t(
        "Please confirm your mobile number for verification purposes"
      );
    } else {
      this.desc = this.$t("Please Enter your mobile number to continue");
    }
   if (($(this.$refs.phoneerror)[0]?.innerText && (this.phone_num == null || this.phone_num == ""))) {
          $(this.$refs.phoneerror)[0].innerText = this.$t("Please Enter your mobile number to continue");
          this.isPhoneNumberPass = false;
   }

   if ($(this.$refs.loginerror)[0].innerText) {
      $(this.$refs.loginerror)[0].innerText = this.$t("Login Error");
   }

    if (!this.registered) {
      this.phonenumber();
    } else {
      this.$refs.phoneerror.innerText = this.$t(
        "The number you entered is registered to an existing account"
      );
    }
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),
    ...mapGetters(["getIsBlock", "isWechat", "getPipl", "getQs"]),
  },
  mounted() {
    this.handleWeChatQueryString()
    console.log("location.host",location.host)
    console.log("isWeChat", this.isWechat)
    console.log("PIPL", this.getPipl("pipl"))
    console.log("validationUrl", this.validationUrl)
    let vm = this;
    this.McaptchaSitekey = 'LDwRutV1teBB2w7NBxviGsjthQQBBvgD'
    const instanceUrl = this.hostname ? `https://${window.location.hostname}` : "https://kdp-mh-uat.k11.com";
    this.McaptchaURL = `${instanceUrl}/widget/?sitekey=${this.McaptchaSitekey}`;
    new mCaptcha.default({widgetLink: new URL(this.McaptchaURL)});
    const r = new Receiver({widgetLink: new URL(this.McaptchaURL)}, (t)=> this.captchaPass(t))
    r.listen()
    $(document).ready(function () {
      (function ($) {
        $.fn.inputFilter = function (inputFilter) {
          return this.on(
            "input keydown keyup mousedown mouseup select contextmenu drop",
            function () {
              if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
              } else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue;
                this.setSelectionRange(
                  this.oldSelectionStart,
                  this.oldSelectionEnd
                );
              } else {
                this.value = "";
              }
            }
          );
        };
      })(jQuery);

      setTimeout(function () {
        $(vm.$refs.phone_num).inputFilter(function (value) {
          console.log("value",value)
          return /^\d*$/.test(value); // Allow digits only, using a RegExp
        });
      }, 2000);
    });
  },
  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest",
    ]),
    ...mapMutations(['setQs','setIsWechat','setWeChatQueryStringRelatedFields']),
    ...mapActions("filters", ["actionFindNow", "actionFindNowById"]),
    ...mapActions(["actionSetForceBlock", "actionSetBlock", "actionSetMiniProgramParams"]),
    handleLaunchFn(e) {
      wx.miniProgram.navigateBack({
        url: this.callbackurl,
        success: function () {
          console.log('success')
        },
        fail: function () {
          console.log('fail');
        },
        complete: function () {
          console.log('complete');
        }
      });
    },
    changeurl() {
      window.sessionStorage.setItem("callbackurl", this.callbackurl);
    },
    switchColor(isCheckboxTextInRed) {
      return isCheckboxTextInRed ? `consents-content-red`: `consents-content`
    },
    phonenumber() {
      if (this.phone_num != null && this.phone_num != "") {
        var inputtxt = this.phone_num;
        if (
          this.selectedCountry == 852 && /:\/\/([^\/]+)/.exec(window.location.href)[1].indexOf("uat") == -1 &&
            (inputtxt.charAt(0) == "2")
        ) {
          $(this.$refs.phoneerror)[0].innerText = `${this.$t("Incorrect format")} ${this.$t("Please provide a valid mobile phone number")}`;
          // this.$refs.sumbit.disabled = true;
          this.isPhoneNumberPass = false;
          return false;
        } else if (this.selectedCountry == 852 && inputtxt.length != 8) {
          $(this.$refs.phoneerror)[0].innerText = this.$t("Phone number is invalidated");
          // this.$refs.sumbit.disabled = true;
          this.isPhoneNumberPass = false;
          return false;
        } else {
           // this.$refs.sumbit.disabled = false;
           this.isPhoneNumberPass = true
          $(this.$refs.phoneerror)[0].innerText = "";
          return true;
        }
      } else if (this.phone_num == "") {
          $(this.$refs.phoneerror)[0].innerText = this.$t("Please Enter your mobile number to continue");
          this.isPhoneNumberPass = false;
      } else {
        // this.$refs.sumbit.disabled = true;
        this.isPhoneNumberPass = false
      }
    },
    onClickCheckbox1() {
      this.isCheckbox1Pass = !this.isCheckbox1Pass
    },
    onClickCheckbox2() {
      this.isCheckbox2Pass = !this.isCheckbox2Pass
    },
    // selectorInputFilter(value) {
    //   return /^\d*$/.test(value); // Allow digits only, using a RegExp
    // },
    onkeyDownHandler(e) {
      if (e.keyCode === 13) {
        $(this.$refs.sumbit).focus();
        event.preventDefault();
        $(this.$refs.sumbit).click();
      }
    },
    onSelect({ name, iso2, dialCode }) {
      this.selectedCountry = dialCode;
      this.phonenumber();
    },
    onCancel() {
      $("#confirmBox").modal("hide");
    },
    onReminderCancel() {
      $("#ReminderBox").modal("hide");
    },
    onContinue() {
      let vm = this;
      var country_code = this.selectedCountry;
      var phone = this.phone_num;
      var kdpmembernumber = this.kdpmembernumber;
      // const mcaptcha__token = $('#mcaptcha__token')
      // this.token = mcaptcha__token[0]?.value
      const token = this.token;
      $.ajax({
        method: "POST",
        contentType: "application/json",
        url: config.serverURI + "/migrationhub/captcha",
        data: JSON.stringify({
          parameters: {
            receiver_value: {
              country_code: country_code,
              value: phone,
              kdp_member_number: kdpmembernumber,
            },
            token: token,
            receiver_type: 2,
            type: 1,
            action: 1,
          },
        }),
        complete: function (jdata) {
          if (jdata.responseJSON != null) {
            if (jdata.responseJSON.success) {
              window.sessionStorage.setItem("action2", 4);
              window.sessionStorage.setItem("k11vipcode", vm.k11vipcode || "");
              window.sessionStorage.setItem("k11accountno", vm.k11accountno || "");
              window.sessionStorage.setItem(
                "kdpmembernumber",
                vm.kdpmembernumber || ""
              );
              window.sessionStorage.setItem("action", 1);
              window.sessionStorage.setItem(
                "sms_log_id",
                jdata.responseJSON.data.sms_log_id
              );
              window.sessionStorage.setItem("callbackurl", vm.callbackurl);
              vm.spinner = false;
              $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
              $(vm.$refs.load).css("z-index", 0);
              window.location.href = "./#/validation";
            } else {
              vm.errormessage =
                vm.$t("Something went wrong") +
                " " +
                jdata.responseJSON.msg[
                  helper.getMappingLocale(vm.$i18n.locale)
                ] +
                "(" +
                jdata.responseJSON.errorcode +
                ")";
              $("#ReminderBox").modal("show");
              vm.spinner = false;
              $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
              $(vm.$refs.load).css("z-index", 0);
            }
          } else {
            vm.errormessage = vm.$t("Network error");
            $("#ReminderBox").modal("show");
            vm.spinner = false;
            $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
            $(vm.$refs.load).css("z-index", 0);
          }
        },
      });
    },
    onVerify(token){
      if (token) {
        this.token = token
      }
    },
    isAbleSumbit() {
      if (!this.isWechat) {
        if (this.isPhoneNumberPass && this.isCheckbox1Pass && this.isCheckbox2Pass && this.token) {
          return true
        }
        return false
      } else {
          return this.isPhoneNumberPass && this.token
      }
    },
    captchaPass(token) {
      if (token) {
        this.token = token
      }
    },
    sumbit() {
      console.log("sumbit")
      if (this.phone_num == null || this.phone_num == "") {
           $(this.$refs.phoneerror)[0].innerText = this.$t("Please Enter your mobile number to continue");
      }
      if (!this.isAbleSumbit()) {
          this.isCheckbox1TextInRed = this.isCheckbox1Pass === false
          this.isCheckbox2TextInRed = this.isCheckbox2Pass === false
          $(this.$refs.loginerror)[0].innerText = this.$t("Login Error");
          return
      }
      $(this.$refs.loginerror)[0].innerText = ""
      // const mcaptcha__token = $('#mcaptcha__token')
      // this.token = mcaptcha__token[0]?.value
      const token = this.token;
      let vm = this;
      this.registered = false;
      var country_code = this.selectedCountry; // $(this.$refs.flagstrap).val();
      var phone = this.phone_num;
      if (country_code == "852") {
        if (phone.length != 8) {
          $(this.$refs.phoneerror)[0].innerText = this.$t(
            "Phone number is invalidated"
          );
          return;
        }
      }
      $(this.$refs.load).css("z-index", "2147483647");

      $(this.$refs.loading)[0].innerText = this.$t("Loading") + " ...";
      vm.spinner = true;
      window.sessionStorage.setItem("phone", phone);
      window.sessionStorage.setItem("country_code", country_code);
      window.sessionStorage.setItem("qs", this.getQs)
      if ($(this.$refs.phoneerror)[0].innerText != "" || phone == "") {
        $(this.$refs.phoneerror)[0].innerText = this.$t(
          "Phone number is invalidated"
        );
        vm.spinner = false;
        $(this.$refs.loading)[0].innerText = this.$t("Continue");
        $(this.$refs.load).css("z-index", 0);
        return false;
      } else {
        console.log("member serach --------------------")
        $.ajax({
          method: "POST",
          contentType: "application/json",
          url: config.serverURI + "/migrationhub/member/search",
          data: JSON.stringify({
            type: "0",
            parameters: {
              phone: {
                country_code: country_code,
                phone_number: phone,
              },
            },
          }),
          complete: function (jdata) {
            if (jdata.responseJSON != null) {
              if (jdata.responseJSON.success) {
                // Search only reveals whether the phone belongs to an
                // existing member; member identifiers are provided by the
                // verification endpoint after OTP verification.
                const { kdp_member_exists, klub11_member_exists, kdp_bind_flag } = jdata.responseJSON.data;

                if (vm.k11purposes == "1") {
                  if (klub11_member_exists) {
                    $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
                    vm.spinner = false;
                    $(vm.$refs.load).css("z-index", 0);
                    vm.registered = true;
                    // return;
                  } else if (!kdp_member_exists) {
                    console.log("/migrationhub/captcha calling")
                    $.ajax({
                      method: "POST",
                      contentType: "application/json",
                      url: config.serverURI + "/migrationhub/captcha",
                      data: JSON.stringify({
                        parameters: {
                          receiver_value: {
                            country_code: country_code,
                            value: phone,
                            kdp_member_number: "",
                          },
                          token: token,
                          receiver_type: 2,
                          type: 1,
                          action: 1,
                        },
                      }),
                      complete: function (jdata2) {
                        console.log("/migrationhub/captcha success")
                        if (jdata.responseJSON != null) {
                          if (jdata2.responseJSON.success) {
                            $(vm.$refs.loading)[0].innerText =
                              vm.$t("Continue");
                            $(vm.$refs.load).css("z-index", 0);
                            window.sessionStorage.setItem(
                              "k11vipcode",
                              vm.k11vipcode || ""
                            );
                            window.sessionStorage.setItem(
                              "k11accountno",
                              vm.k11accountno || ""
                            );

                            window.sessionStorage.setItem("action", 1);
                            window.sessionStorage.setItem(
                              "sms_log_id",
                              jdata2.responseJSON.data.sms_log_id
                            );
                            window.sessionStorage.setItem(
                              "callbackurl",
                              vm.callbackurl
                            );
                            window.sessionStorage.setItem("action2", 1);
                            console.log("going to validation page")
                            window.location.href = "./#/validation";
                          } else {
                            console.log("/migrationhub/captcha failed")
                            $(vm.$refs.loading)[0].innerText =
                              vm.$t("Continue");
                            vm.errormessage =
                              vm.$t("Something went wrong") +
                              // " " +
                              // vm.$t("Please try again later") +
                              " " +
                              jdata2.responseJSON.msg[
                                helper.getMappingLocale(vm.$i18n.locale)
                              ] +
                              "(" +
                              jdata2.responseJSON.errorcode +
                              ")";
                            $("#ReminderBox").modal("show");
                            vm.spinner = false;
                            $(vm.$refs.load).css("z-index", 0);
                          }
                        } else {
                          console.log("Network Error")
                          vm.errormessage = vm.$t("Network error");
                          vm.spinner = false;
                          $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
                          $(vm.$refs.load).css("z-index", 0);
                        }
                      },
                    });
                  } else {
                    console.log("ajax complete10")
                    vm.onContinue();
                  }
                  return;
                }

                if (!kdp_member_exists && !klub11_member_exists) {
                  console.log("ajax complete15")
                  // 4002
                  $.ajax({
                    method: "POST",
                    contentType: "application/json",
                    url: config.serverURI + "/migrationhub/captcha",
                    data: JSON.stringify({
                      parameters: {
                        receiver_value: {
                          country_code: country_code,
                          value: phone,
                        },
                        token: token,
                        receiver_type: 2,
                        type: 2,
                        action: 1,
                      },
                    }),
                    complete: function (jdata2) {
                      if (jdata.responseJSON != null) {
                        if (jdata2.responseJSON.success) {
                          $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
                          $(vm.$refs.load).css("z-index", 0);
                          window.sessionStorage.setItem("action", 1);
                          window.sessionStorage.setItem(
                            "sms_log_id",
                            jdata2.responseJSON.data.sms_log_id
                          );
                          window.sessionStorage.setItem("action2", 3);
                          window.sessionStorage.setItem(
                            "callbackurl",
                            vm.callbackurl
                          );
                          window.location.href = "./#/validation";
                        } else {
                          vm.errormessage =
                            jdata2.responseJSON.msg[
                              helper.getMappingLocale(vm.$i18n.locale)
                            ] +
                            "(" +
                            jdata2.responseJSON.errorcode +
                            ")";
                          $("#ReminderBox").modal("show");
                          vm.spinner = false;
                          $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
                          $(vm.$refs.load).css("z-index", 0);
                        }
                      } else {
                        vm.errormessage = vm.$t("Network error");
                        $("#ReminderBox").modal("show");
                        vm.spinner = false;
                        $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
                        $(vm.$refs.load).css("z-index", 0);
                      }
                    },
                  });
                } else if (kdp_member_exists && klub11_member_exists) {
                  // With Both
                  if (kdp_bind_flag) {
                    vm.errormessage = vm.$t("The phone number was bound");
                    vm.spinner = false;
                    $("#ReminderBox").modal("show");
                    $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
                    $(vm.$refs.load).css("z-index", 0);
                    return;
                  }
                  vm.onContinue();
                } else if (klub11_member_exists) {
                  // 4000
                  $.ajax({
                    method: "POST",
                    contentType: "application/json",
                    url: config.serverURI + "/migrationhub/captcha",
                    data: JSON.stringify({
                      parameters: {
                        receiver_value: {
                          country_code: country_code,
                          value: phone,
                          kdp_member_number: "",
                        },
                        token: token,
                        receiver_type: 2,
                        type: 1,
                        action: 1,
                      },
                    }),
                    complete: function (jdata2) {
                      if (jdata.responseJSON != null) {
                        if (jdata2.responseJSON.success) {
                          $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
                          $(vm.$refs.load).css("z-index", 0);
                          window.sessionStorage.setItem("action", 1);
                          window.sessionStorage.setItem(
                            "sms_log_id",
                            jdata2.responseJSON.data.sms_log_id
                          );
                          window.sessionStorage.setItem("action2", 1);
                          window.sessionStorage.setItem(
                            "callbackurl",
                            vm.callbackurl
                          );
                          window.location.href = "./#/validation";
                        } else {
                          $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
                          vm.errormessage =
                            vm.$t("Something went wrong") +
                            // " " +
                            // vm.$t("Please try again later") +
                            " " +
                            jdata2.responseJSON.msg[
                              helper.getMappingLocale(vm.$i18n.locale)
                            ] +
                            "(" +
                            jdata2.responseJSON.errorcode +
                            ")";
                          vm.spinner = false;
                          $("#ReminderBox").modal("show");
                          $(vm.$refs.load).css("z-index", 0);
                        }
                      } else {
                        vm.errormessage = vm.$t("Network error");
                        $("#ReminderBox").modal("show");
                        vm.spinner = false;
                        $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
                        $(vm.$refs.load).css("z-index", 0);
                      }
                    },
                  });
                } else if (kdp_member_exists) {
                  // 4001
                  $.ajax({
                    method: "POST",
                    contentType: "application/json",
                    url: config.serverURI + "/migrationhub/captcha",
                    data: JSON.stringify({
                      parameters: {
                        receiver_value: {
                          country_code: country_code,
                          value: phone,
                          kdp_member_number: "",
                        },
                        token: token,
                        receiver_type: 2,
                        type: 1,
                        action: 1,
                      },
                    }),
                    complete: function (jdata2) {
                      if (jdata.responseJSON != null) {
                        if (jdata2.responseJSON.success) {
                          window.sessionStorage.setItem(
                            "sms_log_id",
                            jdata2.responseJSON.data.sms_log_id
                          );
                          window.sessionStorage.setItem("action2", 2);
                          window.sessionStorage.setItem("action", 1);
                          window.sessionStorage.setItem(
                            "callbackurl",
                            vm.callbackurl
                          );
                          window.location.href = "./#/validation";
                        }
                      } else {
                        vm.errormessage = vm.$t("Network error");
                        vm.spinner = false;
                        $("#ReminderBox").modal("show");
                        $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
                        $(vm.$refs.load).css("z-index", 0);
                      }
                    },
                  });
                }
              } else {
                vm.errormessage =
                  vm.$t("Something went wrong") +
                  // " " +
                  // vm.$t("Please try again later") +
                  " " +
                  jdata.responseJSON.msg[
                    helper.getMappingLocale(vm.$i18n.locale)
                  ] +
                  "(" +
                  jdata.responseJSON.errorcode +
                  ")";
                $("#ReminderBox").modal("show");

                vm.spinner = false;
                $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
                $(vm.$refs.load).css("z-index", 0);
              }
            } else {
              vm.errormessage = vm.$t("Network error");
              $("#ReminderBox").modal("show");
              vm.spinner = false;
              $(vm.$refs.loading)[0].innerText = vm.$t("Continue");
              $(vm.$refs.load).css("z-index", 0);
            }
          },
        });
      }
    },
    resetWeChatRelatedLocalStorage(){
      const items = ['isWechat', 'unionId', 'k11_optin', 'k11_aff_optin', 'kdp_optin', 'kdp_aff_optin', 'pipl', 'openId', 'openType']
      Promise.all(items.map( key => {
        localStorage.removeItem(key)
      }))
    },
    handleWeChatQueryString() {
      const searchParams = this.url.searchParams
      const wx = window.__wxjs_environment === 'miniprogram' || searchParams.has('uatWeChat')
      // const wx = true
      this.setIsWechat(wx)
      if (wx && this.url.search){
        const params = {}
        const keys = [
          'unionId', 'k11_optin', 'k11_aff_optin', 'kdp_optin', 'kdp_aff_optin', 'openId', 'openType',
          'c1', 'c3', 'c4', 'c5', 'c6', 'c7',
          'k1', 'k3', 'k4', 'k5', 'k6', 'k7'
        ]
        Promise.all(keys.map( key => {
          params[key] = searchParams.has(key) ? searchParams.get(key) : undefined
        }))
        this.setWeChatQueryStringRelatedFields(params)
        console.log("setWeChat", params)
      }
    }
  },
};
</script>